import type { MetaFunction } from "@remix-run/node";
import {
  About,
  Acclaimed,
  FreshReads,
  Home,
  Listen,
  NextRomance,
  PerfectMatch,
  Testimonials,
} from "~/sections";
import { useEffect, useState } from "react";
import { useLocation } from "@remix-run/react";

export const meta: MetaFunction = () => {
  return [
    { title: "Tempt" },
    {
      name: "description",
      content: "Your #1 Romance Audiobook App with Unlimited Listening",
    },
  ];
};

export default function Index() {
  const [currentSection, setCurrentSection] = useState("");
  const location = useLocation();

  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const handleScroll = () => {
      let foundSection = "";
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
          foundSection = section.id;
        }
      });

      if (foundSection && foundSection !== currentSection) {
        setCurrentSection(foundSection);

        const newUrl = `#${foundSection}`;
        if (window.location.hash !== newUrl) {
          window.history.replaceState(null, "", newUrl);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentSection]);

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      const savedSection = sessionStorage.getItem("lastSection");
      if (savedSection) {
        const element = document.querySelector(`#${savedSection}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }, [location]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("lastSection", currentSection);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [currentSection]);

  return (
    <>
      <Home />
      <About />
      <Listen />
      <Acclaimed />
      <FreshReads />
      <PerfectMatch />
      <Testimonials />
      <NextRomance />
    </>
  );
}
